import { Button, IconButton, Tooltip } from "@mui/joy";
import ReplayRoundedIcon from "@mui/icons-material/ReplayRounded";
import CloseRoundedIcon from "@mui/icons-material/ReplayRounded";
import AddRoundedIcon from "@mui/icons-material/AddRounded";

type AddRowButtonProps = {
    onClick: Function;
    includeText?: boolean;
    text?: string;
}

export function AddRowButton({
  onClick,
  includeText = false,
  disabled = false,
  text = 'Add Row',
  sx = {},
}:AddRowButtonProps) {

  if(includeText === true) {
    return (
      <Tooltip title={text}>
        <Button
          startDecorator={<AddRoundedIcon/>}
          size="sm"
          variant="soft"
          color="neutral"
          onClick={onClick}
          disabled={disabled}
          sx={sx}
        >
          {text}
        </Button>
      </Tooltip>
    );
  }

  return (
    <Tooltip title={text}>
      <IconButton
        size="sm"
        color="neutral"
        onClick={onClick}
        disabled={disabled}
        sx={{
          bgcolor: 'background.level1',
          '--variant-outlinedHoverBg': '#FFFFFF6B',
          '--variant-outlinedActiveBg': '#FFFFFFB8',// theme.palette.background.level1
          '--IconButton-size': '1.65rem',
          'svg': {
            width: '1.05rem',
            height: '1.05rem',
          },
          ...sx,
        }}
      >
        <AddRoundedIcon/>
      </IconButton>
    </Tooltip>
  );
}
